<template>
	<el-drawer title="新字段属性" :visible.sync="dialogVisible" :modal-append-to-body="false" size="60%" direction="rtl" 
	class="customer-drawer-common add-edit-effect" >
		<table-pagination :data="data"  :column="column">
			<template v-slot:action="{row,$index}">
				<div class="operate-inline">
					<el-button type="text" size="small" @click="onAdd(row)">添加</el-button>
				</div>
			</template>
			<template v-slot:type="{row}">
				<div style="width: 200px;">
					<el-input disabled :placeholder="row.name" size="mini" v-show="row.type == 'input'" style="width: 100%;"></el-input>
					<el-select disabled  size="mini" v-show="row.type == 'droplist' || row.type == 'cascade'" :value="row.name"  style="width: 100%;">
						<el-option value="下拉选项">下拉选项</el-option>
					</el-select>
					<el-date-picker :value="new Date()" type="date" :placeholder="row.name" disabled size="mini" v-show="row.type == 'date'" style="width: 100%;">
					</el-date-picker>
					<el-time-picker :value="new Date()" :placeholder="row.name" disabled size="mini" v-show="row.type == 'time'" style="width: 100%;">
					</el-time-picker>
					<el-date-picker :value="new Date()" type="datetime" :placeholder="row.name" disabled size="mini" v-show="row.type == 'datetime'" style="width: 100%;">
					</el-date-picker>
					 <el-input-number value="1"  :min="1" disabled  :label="row.name" size="mini" style="width: 100%;" v-show="row.type == 'numerical' || row.type== 'integer'">
					 </el-input-number>
					<el-input disabled :placeholder="row.name" size="mini" v-show="row.type == 'link'" style="width: 100%;">
					    <template slot="prepend">https://</template>
					</el-input>
					<el-radio  disabled v-show="row.type== 'radio'"></el-radio>
					<el-checkbox disabled v-show="row.type== 'checkbox'"></el-checkbox>
					<el-input type="textarea" :rows="2" disabled :placeholder="row.name" size="mini" v-show="row.type == 'text'" style="width: 100%;">
					</el-input>
					<i class="el-icon-upload" v-show="row.type== 'file'" style="font-size: 50px;color: #dfe4ed;"></i>
				</div>
			</template>
		</table-pagination> 
		<detailItem :innerTitle="innerTitle" :displayMode="displayMode" ref="detailItem" @updateList="updateList"></detailItem>
	</el-drawer>
</template>

<script>
	import { custerTypes } from '../../data.js';
	import detailItem from './detailItem.vue';
	export default {
		components: {
			detailItem
		},
		data(){
			return {
				dialogVisible:false,
				column:[
					{ label: "字段名称", prop: "name"},
					{ label: "字段类型模板", prop: "type",slotScope:true},
					{ label: "操作", prop: "action",slotScope:true, align: "center", },
				],
				data:[],
				innerTitle:'',
				displayMode:'',
			}
		},
		methods: {
			onAdd(row) {
				this.displayMode = row.type;
				this.innerTitle = row.name;
				this.$refs.detailItem.openDrawer()
			},
			updateList(){
				this.dialogVisible = false;
				this.$emit('updateList')
			},
			onOpen(){
				this.dialogVisible = true
			}
		},
		mounted(){
			Object.entries(custerTypes).map((item) => {
				this.data.push({
					name:item[1][0],
					type:item[0]
				})
			})
		}
	}
</script>

<style>
</style>
